export default {
  one_time: "One Time",
  title: "Choose the plan that's right for you",
  subtitle: "All new users start with a {0}-day trial — experience Pro features.",
  free: "Free",
  basic: "Basic",
  pro: "Professional",
  month: "per month",
  year: "per year",
  freeSubtitle: "Ideal for individual users and testing",
  basicSubtitle: "Perfect for small and medium businesses",
  proSubtitle: "Perfect for large enterprises and professional teams",
  current: "Current Plan",
  current_plan: "Current Plan",
  try: "Try for Free",
  upgrade: "Upgrade Now",
  contact: "Contact Us",
  contact_sales: "Contact Sales",
  calcs: "calculations",
  reports: "reports",
  calls_per_month: "calls/month",
  keys: "keys",
  calculations: "Carbon Emission Calculations",
  f_reports: "PDF Reports",
  f_factor: "Basic Emission Factors",
  f_no_api: "No API Access",
  f_support: "Email/Ticket Support",
  priority_support: "Priority Technical Support",
  b_reports: "Excel Reports",
  b_factor: "Custom Emission Factors",
  b_custom_logo: "Custom Logo",
  b_api_access: "API Access",
  p_dedicated_support: "Dedicated Customer Support",
  p_custom_solutions: "Custom Solutions",
  p_training: "Team Training Services",
  refund: "If you're not satisfied during the trial period, you can",
  refund_btn: "request a refund",
  refund_suffix: ".",
  powered_by: "Payment services are supported by",
  pay_provider: "paddle",
  paymentLegal: {
    title: "Payment & Legal Notices",
    price_currency:
      "Price: Prices are displayed in EUR and processed securely via Paddle, our Merchant of Record. Applicable taxes may apply based on your location.",
    vat_tax:
      "VAT: Business customers are responsible for any applicable tax declarations. We currently do not charge VAT directly, but Paddle handles tax calculations at checkout where required.",
    payment_method:
      "Payments are securely processed via Paddle, supporting major credit cards, PayPal, Apple Pay, and country-specific payment methods. No custody services are provided.",
    financial_liability:
      "We do not provide investment, trading, or financial advisory services. Access is strictly for SaaS subscription.",
    refund_policy: "Refund Policy:",
    refund_guarantee:
      "We offer a 14-day refund guarantee for all first-time subscription purchases made via Paddle.",
    refund_request:
      "Refund requests can be submitted through the Billing - Orders or by contacting our support team at any time.",
    right_of_withdrawal:
      "By accessing or using any paid features — including CBAM emissions calculations, report generation, API usage, or automated audit computations — you acknowledge and agree that your right of withdrawal is waived in accordance with EU consumer protection regulations for digital services that are fully delivered upon use.",
    subscription_renewals:
      "Refund requests submitted within 7 days after renewal are eligible for a refund. Refund requests submitted after 7 days may qualify for a pro-rated refund based on the unused portion of the billing period. Refunds for renewals are not permitted when paid features have already been used during the current billing cycle.",
    buy_what_you_need:
      "Unused credits may be refunded at any time in full. Used credits are non-refundable.",
    refund_restrictions:
      "Refunds cannot be granted if: A CBAM report has been generated. Emissions calculations or audit-relevant computations have been performed. Any paid API endpoint has been used within the billing period. Fraud, misuse, or abuse of the service is suspected.",
    after_refund_approval:
      "Once a refund is approved: Access to all paid features will be revoked immediately. Your account will be downgraded to the Free plan. All future renewals will be cancelled. Remaining free-plan quota will be restored based on the unconsumed portion of the original free allocation, not reset to full capacity.",
  },
  vat_note: "Prices exclude applicable VAT. EU users are subject to local VAT.",
  pay_per_use_desc: "Pay-as-you-go, no subscription required",
  pay_per_use_benefits_title: "Pay-per-use Benefits",
  pay_per_use_benefit1: "No subscription required",
  pay_per_use_benefit2: "Pay only for what you use",
  pay_per_use_benefit3: "Forever valid",
  buy_credits: "Buy Credits",
  most_popular: "Most Popular",
  save_with_annual: "Save {amount} with annually plan",
  monthly: "Monthly",
  annually: "Annually",
  enterprise: "Enterprise",
  enterpriseSubtitle: "Customized solutions designed for professional users",
  e_custom_solutions: "Custom Solutions",
  start_trial: "{0}-day trial available upon registration",
  all_paid_plans_include_free: "All paid plans include everything in the free plan.",
  fq: {
    title: "Billing & Subscription FAQ",
    plans_q: "What subscription plans are available?",
    plans_a:
      "We offer Free (100 calculations/month), 14-day Trial (500 calculations), Basic (€49/month), Pro (€99/month), and Pay-As-You-Go (€1.5/calculation). Compare details on the pricing page.",
    upgrade_q: "Can I upgrade or downgrade my plan?",
    upgrade_a:
      "Yes, upgrade or downgrade instantly in account settings. Changes apply immediately with prorated adjustments.",
    trial_q: "How does the free trial work?",
    trial_a:
      "New users get a {0}-day Trial with full Pro features. It reverts to Free ({1} calculations) unless upgraded.",
    autocharge_q: "Will my subscription renew automatically?",
    autocharge_a: "Yes, auto-renewal is default. Disable it anytime in billing settings.",
    payment_methods_q: "Which payment methods are supported?",
    payment_methods_a:
      "Payments are securely processed through our official payment provider Paddle, supporting major credit cards, PayPal, Apple Pay, and regional payment methods. VAT and applicable taxes are automatically calculated at checkout by Paddle.",
    invoice_q: "Do you provide VAT invoices?",
    invoice_a:
      "Yes, VAT-compliant invoices are available post-payment. EU customers need a valid VAT ID to qualify for tax exemption.",
    refund_q: "Can I request a refund?",
    refund_a:
      "Refund requests can be submitted via the Subscription page in Account Settings. Refund eligibility follows our 14-day refund policy.",
    data_security_q: "How is my data protected?",
    data_security_a:
      "We comply with GDPR, using encrypted transmission and secure storage. Data is private to your account.",
    cancel_q: "What happens if I cancel?",
    cancel_a:
      "Cancel anytime in subscription settings. Access lasts until the billing cycle ends, then reverts to Free.",
  },
};
